import { Image } from 'antd'
import * as React from 'react'
import { useResizeDetector } from 'react-resize-detector'
import styled from 'styled-components'

interface ImageViewerProps {
  url: string
  height?: number
}

interface ImageContainerProps {
  $height?: number
}

const StyledImage = styled(Image)`
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  object-fit: contain;
  border-radius: 4px;
`

const ImageContainer = styled.div<ImageContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  background: ${({ theme }) => theme.forecast.background2};
  border-radius: 4px;
  overflow: hidden;
`

export const ImageViewer: React.FC<ImageViewerProps> = ({
  url,
  height = 1000,
}) => {
  const { width: detectedWidth, ref } = useResizeDetector<HTMLDivElement>()

  return (
    <ImageContainer ref={ref} $height={height}>
      <StyledImage
        src={url}
        alt='Document preview'
        style={{
          maxWidth: detectedWidth || '100%',
          maxHeight: height,
        }}
        preview={{
          mask: 'Click to preview',
        }}
      />
    </ImageContainer>
  )
}
